import { render, staticRenderFns } from "./MultichoiceAnswer.vue?vue&type=template&id=68ae2529&"
import script from "./MultichoiceAnswer.vue?vue&type=script&lang=ts&"
export * from "./MultichoiceAnswer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports